import { getCategoriesWithProducts } from '../../services/api';

export default {
  namespaced: true,

  state: {
    categories: [],
    products: [],
  },

  actions: {
    async getCategoryProducts({ commit }) {
      const { data } = await getCategoriesWithProducts();

      commit('setCategories', data.categories);
      commit('setProducts', data.products);
    },
  },

  mutations: {
    setCategories(state, categories) {
      state.categories = categories;
    },
    setProducts(state, products) {
      state.products = products;
    },
  },

  getters: {
    getProductsByCategory: (state) => (categoryId) => {
      return state.products
        .filter((product) => product.category_id === categoryId)
        .sort((a, b) => {
          return a.order - b.order;
        });
    },

    getProductById: (state) => (productId) => {
      return state.products.find((product) => product.id === productId);
    },
  },
};
